



























































































































































































































































































































































































































import { mapState, mapGetters, mapActions } from 'vuex'
import SellerInfo from '~/components/car/classifieds/view/partials/seller/SellerInfo.vue'
import UtilButtons from '~/components/car/classifieds/view/partials/UtilButtons.vue'
import CompareViewService from '~/services/compare/CompareViewService'
import UserVerificationChecker from '~/services/user/UserVerificationChecker'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import ImageGallery from '~/components/car/classifieds/view/partials/ImageGallery.vue'
import Specifications from '~/components/car/classifieds/view/partials/Specifications.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import Price from '~/components/car/classifieds/view/partials/Price/Price.vue'
import { CategoryId } from '~/models/category/types'
import { USER_NS } from '~/store/modules/shared/user/state'
import CAdmanAd from '~/components/shared/configurable/ad/CAdmanAd.vue'
import { ADS_NS } from '~/store/modules/shared/ads/state'
import ClassifiedViewAd from '~/components/car/classifieds/view/ClassifiedViewAd.vue'
import InstallmentsService from '~/services/classified/finance/InstallmentsService'
import RelatedClassifiedsAndSearches from '~/components/shared/classified/view/RelatedClassifiedsAndSearches.vue'
import { elementLargerThanScreen } from '~/utils/dom'
import OffersButton from '~/components/shared/classified/offers/OffersButton.vue'
import ClassifiedBadges from '~/components/car/classifieds/view/ClassifiedBadges.vue'
import CTabs from '~/components/shared/configurable/tab/CTabs.vue'
import CTab from '~/components/shared/configurable/tab/CTab.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import KeyFeaturesInColumns from '~/components/car/classifieds/view/partials/key-features/KeyFeaturesInColumns.vue'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'
import Notes from '~/components/car/classifieds/view/partials/Notes.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import { OnlineLoanType } from '~/constants/loan/loans'
import { AccessToggleName } from '~/models/user/access-toggles'
import SaleRequestButton from '~/components/plot/classifieds/view/SaleRequestButton.vue'
import ScrollService from '~/services/scroll/ScrollService'
import CCardHeader from '~/components/shared/configurable/card/CCardHeader.vue'
import Description from '~/components/car/classifieds/view/partials/Description.vue'
import MarketplaceSection from '~/components/car/classifieds/view/partials/MarketplaceSection.vue'
import AuditsButton from '~/components/car/classifieds/view/partials/AuditsButton.vue'
import ViewMobileInfo from '~/components/car/classifieds/view/partials/ViewMobileInfo.vue'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: {
    SaleRequestButton,
    CPosting,
    AuditsButton,
    LoanSection: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/loans/LoanSection.vue')
    ),
    OffersButton,
    CAdmanAd,
    PerpetratorInfo: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/admin/PerpetratorInfo.vue')
    ),
    CCardHeader,
    PromoteBlock: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/PromoteBlock.vue')
    ),
    Extras: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Extras.vue')
    ),
    Certificates: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Certificates.vue')
    ),
    ExternalCertificates: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/ExternalCertificates/ExternalCertificates.vue'
      )
    ),
    Notes,
    Description,
    ProtectedUtilButtons: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/ProtectedUtilsButtons/ProtectedUtilButtons.vue'
      )
    ),
    Finance: defineVue3AsyncComponent(() =>
      import('../partials/finance/Finance.vue')
    ),
    UtilButtons,
    CFloatingContactParking: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/CFloatingContactParking.vue')
    ),
    Map: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Map.vue')
    ),
    PriceChangesChart: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/PriceChangesChart.vue')
    ),
    VehiclePriceStats: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/VehiclePriceStats.vue')
    ),
    Contact: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Contact.vue')
    ),
    CAnonPrompt: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/user/CAnonPrompt.vue')
    ),
    Price,
    Title,
    ImageGallery,
    Specifications,
    ViewMobileInfo,
    KeyFeaturesInColumns,
    QuickSellerInfo: defineVue3AsyncComponent(() =>
      import('~/components/shared/classified/view/QuickSellerInfo.vue')
    ),
    SellerInfo,
    VerifiedUser: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/VerifiedUser.vue')
    ),
    ClassifiedBadges,
    CTabs,
    CTab,
    CCard,
    InstallmentsInfo: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/finance/InstallmentsInfo.vue'
      )
    ),
    LeasingInfo: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/finance/LeasingInfo.vue'
      )
    ),
    ClassifiedViewAd,
    RelatedClassifiedsAndSearches,
    CClassifiedFavoriteButton,
    OnlyTradesAlert: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/OnlyTradesAlert.vue')
    ),
    TradesBlock: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/TradesBlock.vue')
    ),
    PiraeusLoanButton: defineVue3AsyncComponent(() =>
      import(
        '~/components/plot/classifieds/view/piraeus-loan/PiraeusLoanButton.vue'
      )
    ),
    HellasDirectSection: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/insurance/HellasDirectSection.vue'
      )
    ),
    MarketplaceSection
  },
  data() {
    return {
      goToMessagesOnLoad: false,
      contactWrapper: null,
      forceBottom: false,
      notesModalVisible: false,
      activeFinanceTab: 1,
      isFormVisible: false,
      isShowMoreExpanded: false
    }
  },
  computed: {
    componentInstance() {
      return this
    },
    compareViewService() {
      return this.$dep(CompareViewService)
    },
    userVerificationChecker() {
      return this.$dep(UserVerificationChecker)
    },
    ...mapState(ADS_NS, {
      showAdmanAds: state => state.showAdmanAds
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => state.classified,
      refs: state => state.refs,
      seller: state => state.seller,
      showContact: state => state.showContact,
      showContactPrompt: state => state.showContactPrompt,
      classifiedId: state => state.classifiedId,
      leasing: state => state.leasing,
      installments: state => state.installments,
      notes: state => state.notes,
      currentUser: state => state.currentUser,
      audits: state => state.audits
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isWanted: 'isWanted',
      isDamaged: 'isDamaged',
      isForRent: 'isForRent',
      isPromoted: 'isPromoted',
      isDealersOnly: 'isDealersOnly',
      hasLeasing: 'hasLeasing',
      isNew: 'isNew',
      isBoatClassified: 'isBoatClassified',
      sellerIsAnonymous: 'sellerIsAnonymous',
      sellerIsGuest: 'sellerIsGuest',
      sellerIsSingle: 'sellerIsSingle',
      classifiedIsDeleted: 'isDeleted',
      classifiedIsRemoved: 'isRemoved',
      classifiedIsNonPublic: 'isNonPublic',
      classifiedIsHidden: 'isHidden',
      isPlotClassified: 'isPlotClassified',
      shouldShowProtectedUtilButtons: 'shouldShowProtectedUtilButtons',
      userCanViewNotes: 'userCanViewNotes',
      userIsAdminOrOwner: 'userIsAdminOrOwner',
      canViewPromotionInfo: 'canViewPromotionInfo',
      adsKeyValues: 'getKeyValues',
      paidClassified: 'paidClassified',
      getMonthlyInstallmentAmount: 'getMonthlyInstallmentAmount',
      isMapVariant: 'isMapVariant',
      isOnlyTrades: 'isOnlyTrades',
      showLoanSection: 'showLoanSection',
      showLoanCalculator: 'showLoanCalculator',
      showFinance: 'showFinance',
      sellerIsBlacklistedSuspiciousOrFraudster:
        'sellerIsBlacklistedSuspiciousOrFraudster',
      isOwn: 'isOwn',
      shortVideos: 'getShortVideos',
      isVehicleClassified: 'isVehicleClassified',
      isInsuranceAvailable: 'isInsuranceAvailable',
      isUnlisted: 'isUnlisted',
      isGhosted: 'isGhosted',
      isMarketplaceProduct: 'isMarketplaceProduct'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),
    ...mapGetters(USER_NS, {
      userHasPermission: 'hasPermission',
      userIsAdmin: 'isAdmin',
      userCanViewPriceStats: 'userCanViewPriceStats',
      isOfTypeDealer: 'isOfTypeDealer',
      userHasAccessTo: 'userHasAccessTo',
      userIsManager: 'isManager'
    }),
    showSaleRequestButton() {
      return (
        this.userHasAccessTo(AccessToggleName.SALE_REQUESTS_BUY) &&
        this.classified.saleRequests
      )
    },
    monthlyInstallmentAmount() {
      return this.getMonthlyInstallmentAmount(this.$dep(InstallmentsService))
    },
    categoryId(): number {
      return this.$dep(CompareViewService).getViewClassifiedCategoryId()
    },
    showPromoBadge() {
      if (this.isPromoted) {
        return this.$route.query['from-promotion'] || this.userIsAdminOrOwner
      }
      return false
    },
    isExternalCertificatesVisible() {
      return (
        this.classified.external_certificates &&
        Object.keys(this.classified.external_certificates).length > 0
      )
    },
    isInterestZero() {
      return this.classified?.finance?.options?.interestPercentage === 0
    },
    hasTrades() {
      return !!Object.keys(this.classified?.trades?.categories || {}).length
    },
    isDealerSite() {
      return this.$dep(DealerSiteService).routeIsOfDealerSite()
    },
    isPlotCategory() {
      return this.classified.category_ids.includes(CategoryId.PLOT)
    },
    showAuditsButton() {
      return Boolean(this.audits?.available)
    },
    OnlineLoanType() {
      return OnlineLoanType
    },
    userCanViewVehiclePriceStats() {
      if (this.userIsAdmin) {
        return true
      }

      return (
        this.userIsManager &&
        this.userHasAccessTo(AccessToggleName.PERK_VEHICLE_MODEL_PRICE_HISTORY)
      )
    },
    showDescription() {
      const hasDescription = !!(
        this.classified.description?.content?.length ||
        this.classified.description?.length
      )

      const hasTags = this.classified.tags?.length

      return hasDescription || hasTags
    }
  },
  async updated() {
    await this.$nextTick()
    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
  },
  mounted() {
    this.$emit('mounted')

    this.contactWrapper = this.$refs.contactWrapper
    if (this.refs && this.refs.goToMessagesOnLoad) {
      this.goToMessagesOnLoad = this.refs.goToMessagesOnLoad
    }
    this.$store.commit('classifieds/view/SET_REFS', null)
    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)

    if (this.isVehicleClassified) {
      this.$store.dispatch(`${CLASSIFIED_VIEW_NS}/loadAuditsInfo`)
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      scrollToLeasingPartial: 'scrollToLeasingPartial',
      classifiedParkedStateChanged: 'classifiedParkedStateChanged',
      scrollToFinance: 'scrollToFinance'
    }),
    handlePriceChartUpdate() {
      const rightColRef = this.$refs.rightcol

      if (rightColRef) {
        this.forceBottom = elementLargerThanScreen(rightColRef)
      }
    },
    handleSetTab(tab: number) {
      this.scrollToFinance()
      this.activeFinanceTab = tab
    },
    handleContactVisibilityChange(visible: boolean) {
      this.isFormVisible = visible
    },
    handleSpecificationExpand(expanded: boolean) {
      this.isShowMoreExpanded = expanded
    },
    handleExtrasExpand(expanded: boolean) {
      this.isShowMoreExpanded = expanded
    },
    handleBadgeClick(badgeType: string) {
      if (badgeType === 'audit') {
        const elementToScrollTo = document.getElementById('technicalReport')
        if (elementToScrollTo) {
          this.$dep(ScrollService).scrollTo(elementToScrollTo, { offset: -100 })
        }
      }
    }
  },
  i18n: defineComponentTranslations({
    vpn_created: {
      en: 'The classified was created by vpn and is not appearing to users',
      el: 'Η αγγελία δημιουργήθηκε από vpn και δεν εμφανίζεται στους χρήστες'
    },
    ghosted_classified: {
      en: 'The classified is ghosted. Clear the reports to make it visible.',
      el: 'Αυτή η αγγελία είναι ghosted. Καθάρισε τα reports για να εμφανιστεί.'
    }
  })
})
